var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04321 19.1413C9.04321 20.2938 9.97759 21.2282 11.1302 21.2282H17.391C17.391 22.1887 18.1697 22.9673 19.1302 22.9673H21.2171C22.1776 22.9673 22.9562 22.1887 22.9562 21.2282V19.1413H9.04321Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1303 9.05443V13.924C23.1303 14.6912 22.5062 15.3153 21.739 15.3153V17.4022C23.657 17.4022 25.2173 15.8419 25.2173 13.924V9.05443H23.1303Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17354 13.9249C8.17354 14.6921 7.54941 15.3162 6.78223 15.3162V17.4031C8.70016 17.4031 10.2605 15.8428 10.2605 13.9249V9.05534H8.17354V13.9249Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.05443H22.0869V13.924H20V9.05443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8694 11.837C16.8694 12.0288 16.7133 12.1848 16.5216 12.1848C16.3298 12.1848 16.1738 12.0287 16.1738 11.837V9.05435H14.0868V11.837C14.0868 12.0288 13.9308 12.1848 13.739 12.1848C13.5473 12.1848 13.3912 12.0287 13.3912 11.837V9.05435H11.3042V11.837C11.3042 13.1795 12.3964 14.2718 13.739 14.2718C14.2561 14.2718 14.7356 14.1093 15.1303 13.8333C15.525 14.1092 16.0046 14.2718 16.5216 14.2718C16.6258 14.2718 16.7281 14.2645 16.8288 14.2517C16.681 14.861 16.1322 15.3152 15.4781 15.3152V17.4022C17.3961 17.4022 18.9564 15.8418 18.9564 13.9239V11.837V9.05435H16.8694V11.837H16.8694Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3042 15.3155H14.4346V17.4024H11.3042V15.3155Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/saudi-arabia.854d7572.svg";
export { ForwardRef as ReactComponent };